import { Sort } from "../types/sort";
import { TableProps } from "../table/table";

export function defaultSort<TData, TSort>(props: Pick<TableProps<TData, TSort>, 'defaultSort' | 'columns' | 'defaultDirection'>): Sort<TSort> | undefined {
    const column = props.defaultSort || props.columns?.filter(c => c.sort)[0]?.sort;
    if (!column) { return; }
    return {
        column: column,
        direction: props.defaultDirection || 'asc'
    };
}
